import { IntlMessageFormat } from "intl-messageformat";

const compiled = new Map<string, IntlMessageFormat>();

/** ICU text messages; substitutions remain plain text, never markup. */
export function formatMessage(message: string, locale: "de" | "en", values?: Record<string, string | number>): string {
  const key = `${locale}:${message}`;
  let formatter = compiled.get(key);
  if (!formatter) {
    formatter = new IntlMessageFormat(message, locale, undefined, { ignoreTag: true });
    compiled.set(key, formatter);
  }
  const result = formatter.format(values);
  return Array.isArray(result) ? result.join("") : String(result);
}
